var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEMailIconPurple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24.8 17.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__st0 {\n\t\t\tfill: #2f196b\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M12.3 10.3c-.5 0-1-.1-1.5-.5L4.4 5.6c-.5-.3-.6-.9-.3-1.4.3-.5.9-.6 1.4-.3l6.4 4.2c.4.3.5.3 1 0L19.3 4c.5-.3 1.1-.2 1.4.3.3.5.2 1.1-.3 1.4L14 9.8c-.6.3-1.1.5-1.7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M4 17.4c-.1 0-1 0-1.9-.5-1.3-.7-2-1.9-2-3.5L0 4c0-1.2.4-2.1 1.1-2.8C2.2 0 3.8 0 4 0h16.6c.1 0 1 0 2 .5 1.4.6 2.1 1.9 2.1 3.5l.1 9.4c0 1.5-.6 2.4-1.1 2.8-1.2 1.1-2.8 1.1-2.9 1.1L4 17.4zM4 2c-.5 0-2 .2-2 2v9.4c0 .9.3 1.4.9 1.7.5.3 1 .3 1 .3l16.8-.1c.1 0 1 0 1.5-.5.3-.3.5-.8.5-1.4V4c0-.9-.3-1.4-1-1.7-.5-.3-1.1-.3-1.1-.3H4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMailIconPurple);
export default __webpack_public_path__ + "static/media/e-mail_icon_purple.9fbd7921.svg";
export { ForwardRef as ReactComponent };